export default __webpack_public_path__ + "static/media/CO_Dependencies_Graph_public_version.ad128cf5.svg";